import { UnikoServiceTypes } from "src/app/services/payments-api.service";

  export const availableServices = [
    {
      img: '../../../../assets/img/camera.png',
      title: 'preApproval.services.title1',
      description: 'preApproval.services.description1',
      ctaLabel: 'more',
      type: UnikoServiceTypes.photography
    },
    {
      img: '../../../../assets/img/file_property.png',
      title: 'preApproval.services.title2',
      description: 'preApproval.services.description2',
      ctaLabel: 'more',
      type: UnikoServiceTypes.technicalReport
    },
    {
      img: '../../../../assets/img/business_search.png',
      title: 'preApproval.services.title3',
      description: 'preApproval.services.description3',
      ctaLabel: 'more',
      type: UnikoServiceTypes.legalReport
    },
    // {
    //   img: '../../../../assets/img/business_search.png',
    //   title: 'bidding.services.title2',
    //   description: 'bidding.services.description2',
    //   ctaLabel: 'more',
    //   type: UnikoServiceTypes.biddingSupport
    // }
  ]
